import { render, staticRenderFns } from "./couponBox1.vue?vue&type=template&id=e790334e&scoped=true&"
import script from "./couponBox1.vue?vue&type=script&lang=js&"
export * from "./couponBox1.vue?vue&type=script&lang=js&"
import style0 from "./couponBox1.vue?vue&type=style&index=0&id=e790334e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e790334e",
  null
  
)

export default component.exports